<script>
import axios from "axios";
import EmptyState from "@/components/EmptyState.vue";
import TableSkeleton from "@/components/TableSkeleton.vue";
import { saveListView, loadListView } from "@/utils/list-view-store";

const fileDownload = require("js-file-download");

// Yotoqxona 2026-2027: every dormitory (TTJ) contract with its student. Built from the same pieces
// as /contract_2026_2027 (admin-contracts-2026.vue + AdminContract2026List.vue): the filter button
// and button-primary filters, the clickable royal count cards, status tabs, the toolbar with
// search / count badge / EXPORT / Ustunlar, the modern-table and the pager — with that page's
// markup, classes and copy, so App.vue's dark-theme rules for those classes apply here as well.
const STORAGE_KEY = "dormitory2026.table.visibleColumns";
const VIEW_KEY = "dormitory2026.view";
const PANEL = "YOTOQXONA_26_27";
// Tab order = card order; the value is what GET /dormitory/students?status= takes.
const STATUSES = ["ALL", "NOT_PAID", "HALF_PAID", "PAID"];
// Columns added after the list shipped. A saved column choice predates them, so each is added to it
// exactly once (guarded by its marker), as AdminContract2026List's LATE_ADDED_COLUMNS does; unchecked
// afterwards, it stays unchecked.
const LATE_ADDED_COLUMNS = [
  { key: "startDate", marker: "dormitory2026.table.migrated.startDate" },
  { key: "monthlyPrice", marker: "dormitory2026.table.migrated.startDate" },
  { key: "months", marker: "dormitory2026.table.migrated.startDate" },
  { key: "note", marker: "dormitory2026.table.migrated.startDate" },
];

// The filter menus, the same ones (and the same values) as /contract_2026_2027; `param` is the query
// name GET /dormitory/students takes. Nothing ticked means no narrowing, so there is no "Barchasi" row.
const FILTER_KEYS = [
  "kurs", "faculty", "type", "language", "group", "region", "district", "gender", "discount",
  "percent", "docStatus", "role",
];
const FILTER_PARAMS = {
  kurs: "kurs",
  faculty: "selectedEducationFaculties",
  type: "selectedEducationTypes",
  language: "selectedEducationLanguages",
  group: "selectedGroups",
  region: "selectedRegions",
  district: "selectedDistricts",
  gender: "selectedGenders",
  discount: "selectedDiscounts",
  percent: "selectedPaymentPercents",
  docStatus: "selectedDocumentStatus",
  role: "selectedRole",
};
const emptySelection = () => FILTER_KEYS.reduce((o, k) => ({ ...o, [k]: [] }), {});
// ?kurs=1&kurs=2, not axios' kurs[]=1, which Spring would not bind.
const repeatedParams = (params) => {
  const q = new URLSearchParams();
  Object.keys(params).forEach((k) => {
    const v = params[k];
    if (Array.isArray(v)) v.forEach((x) => q.append(k, x));
    else if (v !== null && v !== undefined) q.append(k, v);
  });
  return q.toString();
};

export default {
  name: "AdminDormitory2026",

  components: { EmptyState, TableSkeleton },

  data: () => ({
    loading: false,
    isExport: false,
    canExport: false,
    showFilters: false,
    fromMenu: false,
    toMenu: false,
    from: null,
    to: null,
    search: "",
    sel: emptySelection(),
    noGroup: false,
    openMenu: null,
    menuSearch: "",
    faculties: [],
    groupCodes: [],
    regions: [],
    cities: [],
    promotions: [],
    tab: 0,
    page: 1,
    itemsPerPage: 20,
    rows: [],
    totalElements: 0,
    counts: { all: 0, notPaid: 0, halfPaid: 0, paid: 0, totalDue: 0, totalPaid: 0, totalBalance: 0 },
    tableSettingsOpen: false,
    visibleColumnKeys: [],
    // Vue 2 hides data keys starting with "_" from `this`, so these stay unprefixed.
    deb: null,
    seq: 0,
    restoring: true,
  }),

  computed: {
    allColumns() {
      return [
        { key: "fullName", label: this.$t("Full name") },
        { key: "mobilePhone", label: this.$t("Phone") },
        { key: "faculty", label: this.$t("Faculty") },
        { key: "kurs", label: this.$t("Course") },
        { key: "tuitionContractNumber", label: this.$t("Contract Number") },
        { key: "dormitoryContractNumber", label: this.$t("dormitory_contract_number") },
        { key: "date", label: this.$t("Contract Date") },
        { key: "startDate", label: this.$t("dormitory_start_date") },
        { key: "monthlyPrice", label: this.$t("dormitory_monthly_price") },
        { key: "months", label: this.$t("dormitory_months") },
        { key: "amountDue", label: this.$t("Total Sum") },
        { key: "amountPaid", label: this.$t("Paid sum") },
        { key: "balance", label: this.$t("Ostatok") },
        { key: "note", label: this.$t("dormitory_note") },
      ];
    },
    // Always in allColumns order, however the checkboxes were ticked.
    visibleColumns() {
      return this.allColumns.filter((c) => this.visibleColumnKeys.includes(c.key));
    },
    headers() {
      const base = [{ text: "№", value: "index", sortable: false }];
      const dynamic = this.visibleColumns.map((c) => ({ text: c.label, value: c.key, sortable: false }));
      return [...base, ...dynamic];
    },
    // [{ key, label, items: [{ id, name }] }] in the contract page's order.
    filterDefs() {
      const num = (n) => Array.from({ length: n }, (_, i) => i + 1);
      return [
        { key: "role", label: this.$t("O'QUV TURI"), items: [
          { id: 0, name: this.$t("Imtihon") }, { id: 1, name: this.$t("Magistratura") }] },
        { key: "kurs", label: this.$t("bosqich").toUpperCase(), items: num(5).map((n) => ({ id: n, name: `${n}-${this.$t("bosqich")}` })) },
        { key: "faculty", label: this.$t("TA'LIM YO'NALISHI"), items: this.faculties },
        { key: "type", label: this.$t("TA'LIM SHAKLI"), items: [
          { id: 1, name: this.$t("Kunduzgi ta'lim") }, { id: 2, name: this.$t("Kechki ta'lim") },
          { id: 3, name: this.$t("Sirtqi ta'lim") }, { id: 4, name: this.$t("Kunduzgi 3-smena") }] },
        { key: "language", label: this.$t("TA'LIM TILI"), items: [
          { id: 1, name: this.$t("O'zbek") }, { id: 2, name: this.$t("Rus") }, { id: 3, name: this.$t("Ingliz") }] },
        { key: "group", label: this.$t("GURUH"), items: this.groupCodes.map((c) => ({ id: c, name: c })), noGroup: true },
        { key: "region", label: this.$t("VILOYAT"), items: this.regions },
        { key: "district", label: this.$t("TUMAN"), items: this.districtItems },
        { key: "gender", label: this.$t("JINS"), items: [
          { id: "MALE", name: this.$t("Erkak") }, { id: "FEMALE", name: this.$t("Ayol") }] },
        { key: "discount", label: this.$t("CHEGIRMA"), items: this.promotions.map((d) => ({
          id: d.id, name: d.isPercent ? `${d.promotion}%` : `${d.promotion} so'm` })) },
        { key: "percent", label: this.$t("TO'LOV FOIZI"), items: ["0%", "10%", "25%", "50%", "75%", "100%"].map((n, i) => ({ id: i, name: n })) },
        { key: "docStatus", label: this.$t("HUJJAT HOLATI"), items: [
          { id: 1, name: this.$t("Qisman") }, { id: 2, name: this.$t("To'liq") }] },
      ];
    },
    // Districts narrow to the picked regions, as on the contract page.
    districtItems() {
      const picked = this.sel.region;
      return this.cities.filter((c) => !picked.length || picked.includes(c.regionId));
    },
    hasFilters() {
      return FILTER_KEYS.some((k) => this.sel[k].length) || this.noGroup;
    },
    paginationCount() {
      return Math.max(1, Math.ceil((this.totalElements || 0) / this.itemsPerPage));
    },
  },

  watch: {
    visibleColumnKeys: {
      handler(val) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(val));
        } catch (_) { /* private mode */ }
      },
    },
    search() { this.queue(); },
    sel: { deep: true, handler() { this.queue(); } },
    noGroup() { this.queue(); },
    from() { this.queue(); },
    to() { this.queue(); },
    tab() {
      if (this.restoring) return;
      this.page === 1 ? this.load() : (this.page = 1);
    },
    page() {
      if (!this.restoring) this.load();
    },
  },

  created() {
    const defaults = this.allColumns.map((c) => c.key);
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      this.visibleColumnKeys = this.applyLateAddedColumns(Array.isArray(saved) && saved.length
        ? saved.filter((k) => defaults.includes(k))
        : defaults);
    } catch (_) {
      this.visibleColumnKeys = defaults;
    }

    // Coming back from a student's page with "Orqaga" lands on the same tab, page and search.
    const view = loadListView(VIEW_KEY);
    if (view) {
      this.tab = Number(view.tab) || 0;
      this.page = Number(view.page) || 1;
      this.search = view.search || "";
      this.from = view.from || null;
      this.to = view.to || null;
      this.sel = { ...emptySelection(), ...(view.sel || {}) };
      this.noGroup = !!view.noGroup;
      this.showFilters = !!(view.from || view.to || this.hasFilters);
    }
  },

  async mounted() {
    this.$nextTick(() => { this.restoring = false; });
    this.fetchCounts();
    this.load();
    this.loadFilterOptions();
    this.canExport = await this.hasPermission("EXCEL");
  },

  beforeDestroy() {
    if (this.deb) clearTimeout(this.deb);
  },

  methods: {
    queue() {
      if (this.restoring) return;
      if (this.deb) clearTimeout(this.deb);
      this.deb = setTimeout(() => {
        this.page === 1 ? this.load() : (this.page = 1);
      }, 400);
    },

    params() {
      const p = {};
      if (this.search && this.search.trim()) p.search = this.search.trim();
      if (this.from) p.from = this.from;
      if (this.to) p.to = this.to;
      if (STATUSES[this.tab] !== "ALL") p.status = STATUSES[this.tab];
      FILTER_KEYS.forEach((k) => {
        if (this.sel[k].length) p[FILTER_PARAMS[k]] = this.sel[k].map(String);
      });
      if (this.noGroup) p.noGroup = true;
      return p;
    },

    // Each list is its own request, so one that fails (e.g. no right to read groups) only empties its menu.
    async loadFilterOptions() {
      const get = (url) => axios.get(url).then((r) => r.data).catch(() => null);
      const name = (n) => (n && (n.uz || n.en || n.ru)) || "---";
      const [faculties, groups, regions, cities, promotions] = await Promise.all([
        get("admin/faculty/all"),
        get("api/groups/get/codes"),
        get("admin/region?page=0&size=120&name=null&sortField=&sortOrder=asc"),
        get("admin/city?page=0&size=1000&name=null&sortField=&sortOrder=asc"),
        get("/admin/promotions"),
      ]);
      this.faculties = (Array.isArray(faculties) ? faculties : []).map((f) => ({ id: f.id, name: f.name }));
      this.groupCodes = Array.from(new Set((Array.isArray(groups) ? groups : []).map(String)))
        .sort((a, b) => a.localeCompare(b, "en"));
      this.regions = ((regions && regions.content) || []).map((r) => ({ id: r.id, name: name(r.names) }));
      this.cities = ((cities && cities.content) || []).map((c) => ({
        id: c.id, name: name(c.names), regionId: c.region ? c.region.id : (c.regionId != null ? c.regionId : null) }));
      this.promotions = Array.isArray(promotions) ? promotions : [];
    },

    menuItems(def) {
      const q = (this.menuSearch || "").trim().toLowerCase();
      return q ? def.items.filter((i) => String(i.name).toLowerCase().includes(q)) : def.items;
    },

    filterLabel(def) {
      const picked = def.items.filter((i) => this.sel[def.key].includes(i.id)).map((i) => i.name);
      if (!picked.length) return def.label;
      return picked.length === 1 ? picked[0] : `${picked[0]}, ..`;
    },

    clearFilters() {
      this.sel = emptySelection();
      this.noGroup = false;
    },

    async load() {
      const seq = ++this.seq;
      this.loading = true;
      saveListView(VIEW_KEY, {
        tab: this.tab, page: this.page, search: this.search, from: this.from, to: this.to,
        sel: this.sel, noGroup: this.noGroup,
      });
      try {
        const res = await axios.get("/dormitory/students", {
          params: { ...this.params(), page: this.page - 1, size: this.itemsPerPage },
          paramsSerializer: repeatedParams,
        });
        if (seq !== this.seq) return; // a newer filter already answered
        const d = res.data || {};
        this.rows = d.content || [];
        this.totalElements = d.totalElements || 0;
      } catch (e) {
        if (seq !== this.seq) return;
        console.error("Failed to load dormitory students", e);
        this.rows = [];
        this.totalElements = 0;
      } finally {
        if (seq === this.seq) this.loading = false;
      }
    },

    async fetchCounts() {
      try {
        const res = await axios.get("/dormitory/count");
        this.counts = { ...this.counts, ...(res.data || {}) };
      } catch (e) {
        console.error("Failed to load dormitory counts", e);
      }
    },

    selectTab(i) {
      this.tab = i;
    },

    onClear() {
      this.search = "";
    },

    onExport() {
      this.isExport = true;
      axios
        .get("/dormitory/students/export", { params: this.params(), paramsSerializer: repeatedParams, responseType: "blob" })
        .then((res) => {
          if (res && res.data) {
            const date = new Date().toISOString().substr(0, 10);
            fileDownload(res.data, `yotoqxona_2026_2027_${date}.xlsx`);
          }
        })
        .catch((e) => console.error("Dormitory export failed", e))
        .finally(() => {
          this.isExport = false;
        });
    },

    // One-time and additive: see LATE_ADDED_COLUMNS.
    applyLateAddedColumns(saved) {
      const keys = saved.slice();
      for (const { key, marker } of LATE_ADDED_COLUMNS) {
        let done = false;
        try {
          done = localStorage.getItem(marker) === "1";
        } catch (_) {
          continue; // no storage: never re-add on every visit
        }
        if (!done && !keys.includes(key)) keys.push(key);
      }
      for (const { marker } of LATE_ADDED_COLUMNS) {
        try {
          localStorage.setItem(marker, "1");
        } catch (_) { /* private mode */ }
      }
      return keys;
    },

    toggleAllColumns() {
      const all = this.allColumns.map((c) => c.key);
      const isAll = this.visibleColumnKeys.length === all.length;
      this.visibleColumnKeys = isAll ? [] : all;
    },
    resetColumns() {
      this.visibleColumnKeys = this.allColumns.map((c) => c.key);
    },

    onOpen(item) {
      this.$router.push({ path: `/contract_2026_2027-show/${item.contractId}`, query: { tab: "yotoqxona" } });
    },

    getCell(item, key) {
      switch (key) {
        case "mobilePhone":
          return this.$tel && item.mobilePhone ? this.$tel(item.mobilePhone) : (item.mobilePhone || "");
        case "kurs":
          return item.kurs ? `${item.kurs} kurs` : "";
        case "date":
        case "startDate":
          return item[key] && this.$date ? this.$date(item[key]) : (item[key] || "");
        case "months":
          return item.months ? `${item.months} oy` : "";
        case "monthlyPrice":
        case "amountDue":
        case "amountPaid":
        case "balance":
          return this.formatCurrency(item[key]);
        default:
          // Lookup columns arrive as { id, name }; show the name, never the raw object.
          {
            const v = item && key in item ? item[key] ?? "" : "";
            if (v === null || typeof v !== "object") return v;
            return Array.isArray(v)
              ? v.map((x) => (x && typeof x === "object" ? x.name : x)).join(", ")
              : v.name ?? "";
          }
      }
    },

    formatCurrency(value) {
      if (value == null) return "";
      return new Intl.NumberFormat("uz-UZ", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value) + " so'm";
    },

    pct(n) {
      return ((Number(n) || 0) / (Number(this.counts.all) || 1) * 100).toFixed(0) + "%";
    },
    moneyPct(n) {
      const due = Number(this.counts.totalDue) || 0;
      return due > 0 ? Math.min(100, Math.max(0, (Number(n) || 0) / due * 100)).toFixed(0) + "%" : "0%";
    },

    async hasPermission(op) {
      try {
        const res = await axios.get("/admin/panel-permissions/check", { params: { appPanel: PANEL, op } });
        return res.data === true;
      } catch {
        return false;
      }
    },
  },
};
</script>

<template>
  <div>
    <div style="margin-bottom: 24px; display: flex; justify-content: flex-end; padding-right: 20px;">
      <v-btn
        class="filter-btn"
        elevation="2"
        large
        rounded
        @click="showFilters = !showFilters"
      >
        <img src="../../assets/filter.svg" alt="Filter Icon" style="margin-right: 8px;">
      </v-btn>
    </div>

    <v-fade-transition>
      <v-container v-if="showFilters" fluid>
        <div class="filter-row">
          <v-menu
            v-model="fromMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" :class="{ 'button-primary--selected': !!from }" v-bind="attrs" v-on="on">
                {{ from ? $date(from) : $t("dormitory_date_from") }}
              </v-btn>
            </template>

            <v-card :style="{ backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important' }">
              <v-date-picker v-model="from" :max="to || undefined" no-title scrollable @input="fromMenu = false"/>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn text @click="from = null; fromMenu = false">{{ $t("Clear") }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="fromMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            v-model="toMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" :class="{ 'button-primary--selected': !!to }" v-bind="attrs" v-on="on">
                {{ to ? $date(to) : $t("dormitory_date_to") }}
              </v-btn>
            </template>

            <v-card :style="{ backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important' }">
              <v-date-picker v-model="to" :min="from || undefined" no-title scrollable @input="toMenu = false"/>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn text @click="to = null; toMenu = false">{{ $t("Clear") }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="toMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            v-for="def in filterDefs"
            :key="def.key"
            :value="openMenu === def.key"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
            @input="(v) => { openMenu = v ? def.key : null; menuSearch = ''; }">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="button-primary"
                :class="{ 'button-primary--selected': sel[def.key].length || (def.noGroup && noGroup) }"
                v-bind="attrs"
                v-on="on"
                style="max-width: 274px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ filterLabel(def) }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }">
              <v-card-title>
                <v-text-field v-model="menuSearch" :label="$t('Qidiruv')" clearable hide-details dense />
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-if="def.noGroup"
                    v-model="noGroup"
                    :label="$t('Guruh biriktirilmagan')"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="width: 100%;"
                  />
                  <v-checkbox
                    v-for="item in menuItems(def)"
                    :key="item.id"
                    v-model="sel[def.key]"
                    :label="item.name"
                    :value="item.id"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                  />
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="sel[def.key] = []; if (def.noGroup) noGroup = false">{{ $t("Clear") }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="openMenu = null">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-btn v-if="hasFilters" text class="button-primary" @click="clearFilters">{{ $t("Clear") }}</v-btn>
        </div>
      </v-container>
    </v-fade-transition>

    <v-container
      fluid
      class="royal-row"
      role="group"
      aria-label="Dormitory stats">
      <div class="royal-grid">
        <!-- ALL -->
        <v-card
          class="royal-card royal--all"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="selectTab(0)"
        >
          <div class="royal-title" v-text="$t('All Contract')" />
          <div class="royal-count">{{ counts.all | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: '100%' }"></span>
          </div>
        </v-card>

        <!-- NOT PAID -->
        <v-card
          class="royal-card royal--not"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="selectTab(1)"
        >
          <div class="royal-title">{{ $t('Not Paid Contract') }}</div>
          <div class="royal-count">{{ counts.notPaid | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: pct(counts.notPaid) }"></span>
          </div>
        </v-card>

        <!-- HALF PAID -->
        <v-card
          class="royal-card royal--half"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="selectTab(2)"
        >
          <div class="royal-title">{{ $t('Half Paid Contract') }}</div>
          <div class="royal-count">{{ counts.halfPaid | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: pct(counts.halfPaid) }"></span>
          </div>
        </v-card>

        <!-- PAID -->
        <v-card
          class="royal-card royal--paid"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="selectTab(3)"
        >
          <div class="royal-title">{{ $t('Paid Contract') }}</div>
          <div class="royal-count">{{ counts.paid | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: pct(counts.paid) }"></span>
          </div>
        </v-card>

        <!-- SUMS: what is owed, paid and left over every dormitory contract -->
        <v-card class="royal-card royal--all" elevation="0">
          <div class="royal-title">{{ $t('Total Sum') }}</div>
          <div class="royal-count">{{ counts.totalDue | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: Number(counts.totalDue) > 0 ? '100%' : '0%' }"></span>
          </div>
        </v-card>

        <v-card class="royal-card royal--paid" elevation="0">
          <div class="royal-title">{{ $t('Paid sum') }}</div>
          <div class="royal-count">{{ counts.totalPaid | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: moneyPct(counts.totalPaid) }"></span>
          </div>
        </v-card>

        <v-card class="royal-card royal--not" elevation="0">
          <div class="royal-title">{{ $t('Ostatok') }}</div>
          <div class="royal-count">{{ counts.totalBalance | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: moneyPct(counts.totalBalance) }"></span>
          </div>
        </v-card>
      </div>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-card class="position-relative" outlined style="overflow: hidden;">
            <v-tabs v-model="tab" color="accent">
              <v-tab :disabled="loading" class="transform-none tab-upper" v-text="$t('All Contract')" />
              <v-tab :disabled="loading" class="transform-none tab-upper" v-text="$t('Not Paid Contract')" />
              <v-tab :disabled="loading" class="transform-none tab-upper" v-text="$t('Half Paid Contract')" />
              <v-tab :disabled="loading" class="transform-none tab-upper" v-text="$t('Paid Contract')" />
            </v-tabs>

            <!-- ── Toolbar: Search (left) + Actions (right) ── -->
            <div class="toolbar-row">
              <v-text-field
                :placeholder="$t('Izlash...')"
                append-icon="mdi-magnify"
                v-model="search"
                dense
                hide-details
                outlined
                clearable
                class="search-input"
                @click:clear="onClear"
              />

              <div class="circle-actions">
                <v-chip class="badge-count" color="primary" small>
                  {{ totalElements || 0 }}
                </v-chip>

                <v-btn
                  v-if="canExport"
                  :loading="isExport"
                  class="ml-2 modern-button modern-export"
                  @click="onExport"
                >
                  <img src="/icons/excel-icon.svg" alt="Excel" class="export-icon">
                  EXPORT
                </v-btn>

                <!-- Columns menu -->
                <v-menu
                  v-model="tableSettingsOpen"
                  offset-y
                  left
                  :close-on-content-click="false"
                  :allow-overflow="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-2 modern-button font-made" v-bind="attrs" v-on="on">
                      <img src="/icons/column-list-icon.svg" alt="Columns" style="width:13px;height:13px;opacity:0.6;margin-right:6px" :style="$vuetify.theme.dark ? 'filter:brightness(0) invert(1);opacity:0.7' : ''">
                      {{ $t("Columns") }}
                    </v-btn>
                  </template>

                  <v-card class="columns-menu-card">
                    <v-list dense class="columns-menu-list">
                      <v-subheader>{{ $t("Show/Hide Columns") }}</v-subheader>

                      <v-list-item>
                        <v-btn small text class="mr-2" @click="toggleAllColumns">
                          <v-icon left small>mdi-select-all</v-icon>
                          {{ $t("Select all") }}
                        </v-btn>
                        <v-btn small text @click="resetColumns">
                          <v-icon left small>mdi-undo</v-icon>
                          {{ $t("Reset defaults") }}
                        </v-btn>
                      </v-list-item>

                      <v-divider class="my-1" />

                      <v-list-item
                        v-for="col in allColumns"
                        :key="col.key"
                        class="columns-menu-item"
                      >
                        <v-checkbox
                          dense
                          hide-details
                          :label="col.label"
                          :value="col.key"
                          v-model="visibleColumnKeys"
                        />
                      </v-list-item>
                    </v-list>

                    <div class="columns-menu-footer">
                      <v-btn small class="columns-apply-btn" @click="tableSettingsOpen = false">
                        {{ $t("Apply") }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-menu>
              </div>
            </div>

            <v-data-table
              :mobile-breakpoint="0"
              :loading="loading"
              hide-default-footer
              disable-pagination
              :headers="headers"
              class="modern-table"
              :items="rows"
              :server-items-length="totalElements"
              item-key="dormitoryContractId"
              style="height: auto;"
            >
              <template v-slot:body="props">
                <tbody>
                  <tr v-for="(item, i) in props.items" :key="item.dormitoryContractId" class="modern-row">
                    <td @click="onOpen(item)">{{ (page - 1) * itemsPerPage + i + 1 }}</td>

                    <td
                      v-for="col in visibleColumns"
                      :key="col.key"
                      :class="{ 'cell-nowrap': !['fullName', 'faculty', 'note'].includes(col.key) }"
                      @click="onOpen(item)"
                    >
                      {{ getCell(item, col.key) }}
                    </td>
                  </tr>

                  <tr v-if="loading && !props.items.length">
                    <td :colspan="props.headers.length">
                      <table-skeleton :cols="props.headers.length" />
                    </td>
                  </tr>
                  <tr v-else-if="!props.items.length">
                    <td :colspan="props.headers.length">
                      <empty-state :title="$t('No results found')" />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>

            <div class="pt-2 pb-2">
              <v-pagination
                :total-visible="10"
                v-model="page"
                :length="paginationCount"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
/* Copied from /contract_2026_2027 — admin-contracts-2026.vue (filter button, filter row, royal
   cards) and AdminContract2026List.vue (toolbar, buttons, columns menu, table) — so the two pages
   match; App.vue carries the dark-theme overrides for these class names. */

/* ── Filter button + row (admin-contracts-2026.vue) ── */
.filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #f5f5f5 !important;
  color: #f5f5f5;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: none;
  border: 1px solid #d0d5dd;
  text-transform: uppercase;
  min-width: 10px!important;
  border-radius: 20px;
  padding: 0 12.555556px!important;
}
.filter-btn img {
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-right: 0!important;
}
.filter-btn:hover {
  background-color: #1570ef;
}
.filter-btn:active {
  background-color: #175cd3;
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.filter-row > * {
  flex: 0 1 calc(33.333% - 11px);
}
.button-primary {
  background-color: #ffffff;
  border: 1px solid #d0d5dd;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 10px;
  transition: all 0.15s ease-in-out;
  box-shadow: none;
  cursor: pointer;
  text-transform: none;
}
.button-primary:hover {
  background-color: #f9fafb;
  border-color: #c0c7d0;
}
.button-primary:active {
  background-color: #f0f2f5;
  box-shadow: none;
}
.button-primary--selected {
  background-color: #2e90fa;
  border-color: #2e90fa;
  color: #ffffff;
  box-shadow: none;
}

/* ── Royal cards (admin-contracts-2026.vue) ── */
$radius: 14px;
$gap: 14px;
$line: #e6e8ec;
$ink: #0f172a;
$muted: #667085;

$royal-blue:   #3451e6;  // All
$imperial-red: #c81e1e;  // Not paid
$amber-gold:   #b88300;  // Half paid
$emerald:      #148b4b;  // Paid

.royal-row { padding: 8px 12px; }
.royal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: $gap;
  @media (max-width: 1280px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 960px)  { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 560px)  { grid-template-columns: 1fr; }
}

.royal-card {
  position: relative;
  overflow: hidden; /* keep stripe inside radius */
  cursor: pointer;
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 16px;
  min-height: 92px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  transition: border-color .18s ease, transform .18s ease, background-color .18s ease;
  outline: none;

  /* subtle interactions */
  &:hover  { border-color: #d7d9df; }
  &:focus { outline: none; }

  /* hover wave */
  &::after {
    content: "";
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,.03), transparent);
    transform: translateX(-100%); pointer-events: none;
  }
  &:hover::after { animation: wave 1200ms ease; }

  /* initial mount reveal */
  animation: slideUpFade .38s ease both;
}
/* The contract page's cards carry a 4px ::before stripe that Vuetify's clickable-card rule
   (.v-card--link:before, opacity 0) keeps invisible. The sum cards below are not clickable, so
   the stripe is left out altogether: every card then looks the way the contract page's do. */
.royal-card:not(.v-card--link) { cursor: default; }
.royal-card:nth-child(1){ animation-delay: 40ms; }
.royal-card:nth-child(2){ animation-delay: 80ms; }
.royal-card:nth-child(3){ animation-delay: 120ms; }
.royal-card:nth-child(4){ animation-delay: 160ms; }

.royal-title{
  color: $muted;
  font-size: 12px; line-height: 1;
  letter-spacing: .08em;
  text-transform: uppercase;
  font-weight: 700;
}
.royal-count{
  color: $ink; /* stays black */
  font-weight: 900;
  font-size: clamp(24px, 3.6vw, 36px);
  line-height: 1.05;
  letter-spacing: -0.2px;
  font-variant-numeric: tabular-nums lining-nums;
}

/* ratio meter */
.royal-meter{
  height: 6px; margin-top: 6px;
  border-radius: 999px; background: #f1f3f5; overflow: hidden;
  > span{ display:block; height:100%; width:0%; transition: width .45s cubic-bezier(.2,.8,.2,1); }
}

/* per-variant colors (no CSS vars) */
.royal-card.royal--all  { .royal-meter>span{ background:$royal-blue;   } }
.royal-card.royal--not  { .royal-meter>span{ background:$imperial-red; } }
.royal-card.royal--half { .royal-meter>span{ background:$amber-gold;   } }
.royal-card.royal--paid { .royal-meter>span{ background:$emerald;      } }

/* animations */
@keyframes wave {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* reduced motion */
@media (prefers-reduced-motion: reduce) {
  .royal-card,
  .royal-meter>span { transition: none; animation: none; }
}

/* ── Toolbar Row (AdminContract2026List.vue) ── */
.toolbar-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 20px 12px;
}

.toolbar-row > .search-input {
  flex: 1;
  min-width: 0;
}

.circle-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  max-width: 100%;
  flex-wrap: wrap;
  row-gap: 10px;
}

.circle-actions > * {
  flex-shrink: 0;
}

/* ── Search Input ── */
.search-input {
  max-width: none;
}

::v-deep .search-input {
  .v-input__slot {
    background: #f1f5f9 !important;
    border-radius: 10px !important;
    min-height: 38px !important;
  }
  fieldset {
    border-color: transparent !important;
  }
  &:hover fieldset {
    border-color: #d0d5dd !important;
  }
  &.v-input--is-focused fieldset {
    border-color: #00274c !important;
    border-width: 1.5px !important;
  }
  .v-icon {
    color: #94a3b8 !important;
    font-size: 20px !important;
  }
  input {
    font-size: 14px;
  }
  input::placeholder {
    color: #94a3b8 !important;
  }
}

::v-deep .search-input.theme--dark {
  .v-input__slot {
    background: #22232e !important;
  }
  fieldset {
    border-color: transparent !important;
  }
  &:hover fieldset {
    border-color: #33354a !important;
  }
  &.v-input--is-focused fieldset {
    border-color: #ffd451 !important;
  }
  .v-icon {
    color: #606275 !important;
  }
  input {
    color: #d5d6de !important;
  }
  input::placeholder {
    color: #606275 !important;
  }
}

.modern-button {
  text-transform: none;
  border-radius: 8px;
  padding: 8px 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modern-export {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px !important;
  background: #217346 !important;
  color: #fff !important;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600 !important;
  letter-spacing: .03em;
  text-transform: none !important;
  transition: all .2s ease;
  height: 36px !important;
  min-width: 130px !important;
}
.modern-export:hover {
  background: #1a5c38 !important;
}
.modern-export:active {
  transform: scale(.97);
}
.export-icon {
  width: 18px;
  height: 18px;
  filter: brightness(0) invert(1);
  margin-right: 10px;
}

.modern-table {
  border-radius: 8px;
  overflow: hidden;
  max-width: 100%;
}

.modern-row:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

/* This table has far fewer columns than the contract list, so it fits without scrolling and the
   browser squeezes it instead: keep codes, dates and sums on one line the way they sit on the
   (scrolling) contract table, and let only names wrap. */
.cell-nowrap {
  white-space: nowrap;
}

/* v-data-table height adjustment */
::v-deep .v-data-table--fixed-height .v-data-table__wrapper {
  height: auto !important;
  max-height: none !important;
}

/* Badge count chip */
.badge-count {
  font-size: 12px !important;
  padding: 4px 10px !important;
  font-weight: 600 !important;
}
.badge-count.primary {
  color: white !important;
}
.theme--dark .badge-count.primary {
  color: #111318 !important;
}

.columns-menu-card {
  min-width: 260px;
  max-height: 360px;
  display: flex;
  flex-direction: column;
}

.columns-menu-list {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 0 !important;
}

.columns-menu-item {
  padding: 0 12px !important;
  min-height: 32px !important;
}

::v-deep .columns-menu-item .v-input--checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.columns-menu-footer {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  padding: 8px 12px;
  border-top: 1px solid #e6e8ec;
  background: inherit;
}

.theme--dark .columns-menu-footer {
  border-top-color: #2a2c3a;
}

.columns-apply-btn.v-btn {
  background-color: #ffd451 !important;
  color: #111318 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-radius: 8px !important;
}
.columns-apply-btn.v-btn:hover {
  background-color: #f5c542 !important;
}

/* Sticky № + F.I.O columns (the contract list sticks its checkbox + F.I.O the same way) */
::v-deep .v-data-table__wrapper th:nth-child(1),
::v-deep .v-data-table__wrapper td:nth-child(1) {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  width: 48px;
  min-width: 48px;
}
::v-deep .v-data-table__wrapper th:nth-child(2),
::v-deep .v-data-table__wrapper td:nth-child(2) {
  position: sticky !important;
  left: 48px !important;
  z-index: 3 !important;
}
::v-deep .v-data-table__wrapper th:nth-child(1),
::v-deep .v-data-table__wrapper th:nth-child(2) {
  z-index: 5 !important;
}
.theme--light ::v-deep .v-data-table__wrapper td:nth-child(1),
.theme--light ::v-deep .v-data-table__wrapper td:nth-child(2),
.theme--light ::v-deep .v-data-table__wrapper th:nth-child(1),
.theme--light ::v-deep .v-data-table__wrapper th:nth-child(2) {
  background-color: #fff !important;
}
.theme--dark ::v-deep .v-data-table__wrapper td:nth-child(1),
.theme--dark ::v-deep .v-data-table__wrapper td:nth-child(2),
.theme--dark ::v-deep .v-data-table__wrapper th:nth-child(1),
.theme--dark ::v-deep .v-data-table__wrapper th:nth-child(2) {
  background-color: #1e1e2d !important;
}
.theme--light ::v-deep .modern-row:hover td:nth-child(1),
.theme--light ::v-deep .modern-row:hover td:nth-child(2) {
  background-color: #f5f5f5 !important;
}
.theme--dark ::v-deep .modern-row:hover td:nth-child(1),
.theme--dark ::v-deep .modern-row:hover td:nth-child(2) {
  background-color: #2a2a3d !important;
}
/* Visible horizontal scrollbar */
::v-deep .v-data-table__wrapper {
  overflow-x: auto !important;
}
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px;
}
::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 5px;
}
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #888;
}
.theme--dark ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #1e1e2d;
}
.theme--dark ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #444;
}
</style>
